module.exports = __webpack_public_path__ + "static/img/hotWord1.67690640.png";